import { render, staticRenderFns } from "./jcShopOilOrderList.vue?vue&type=template&id=4f4de964&scoped=true"
import script from "./jcShopOilOrderList.vue?vue&type=script&lang=js"
export * from "./jcShopOilOrderList.vue?vue&type=script&lang=js"
import style0 from "./jcShopOilOrderList.vue?vue&type=style&index=0&id=4f4de964&prod&scoped=true&lang=css"
import style1 from "./jcShopOilOrderList.vue?vue&type=style&index=1&id=4f4de964&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4de964",
  null
  
)

export default component.exports